import LongLat from "@mapmycustomers/shared/types/base/LongLat";

import EditBoundsCommand, {
  Paths,
} from "@app/scene/map/components/TerritoriesMode/types/EditBoundsCommand";

export class InsertVertexCommand implements EditBoundsCommand {
  private readonly pathIndex: number;
  private readonly insertAt: number;
  private readonly coordinate: LongLat;

  constructor(pathIndex: number, insertAt: number, coordinate: LongLat) {
    this.pathIndex = pathIndex;
    this.insertAt = insertAt;
    this.coordinate = coordinate;
  }

  apply(paths: Paths): Paths {
    const newPaths = [...paths];
    newPaths[this.pathIndex] = [...paths[this.pathIndex]];
    newPaths[this.pathIndex].splice(this.insertAt, 0, this.coordinate);
    return newPaths;
  }

  revert(paths: Paths): Paths {
    const newPaths = [...paths];
    newPaths[this.pathIndex] = [...paths[this.pathIndex]];
    newPaths[this.pathIndex].splice(this.insertAt, 1);
    return newPaths;
  }
}

export class UpdateVertexCommand implements EditBoundsCommand {
  private readonly pathIndex: number;
  private readonly updateAt: number;
  private readonly newCoordinate: LongLat;
  private oldCoordinate?: LongLat;

  constructor(pathIndex: number, insertAt: number, newCoordinate: LongLat) {
    this.pathIndex = pathIndex;
    this.updateAt = insertAt;
    this.newCoordinate = newCoordinate;
  }

  apply(paths: Paths): Paths {
    this.oldCoordinate = paths[this.pathIndex][this.updateAt];

    const newPaths = [...paths];
    newPaths[this.pathIndex] = [...paths[this.pathIndex]];
    newPaths[this.pathIndex].splice(this.updateAt, 1, this.newCoordinate);
    return newPaths;
  }

  revert(paths: Paths): Paths {
    if (!this.oldCoordinate) {
      return paths;
    }

    const newPaths = [...paths];
    newPaths[this.pathIndex] = [...paths[this.pathIndex]];
    newPaths[this.pathIndex].splice(this.updateAt, 1, this.oldCoordinate);
    this.oldCoordinate = undefined;
    return newPaths;
  }
}

export class RemoveVertexCommand implements EditBoundsCommand {
  private readonly pathIndex: number;
  private readonly removeAt: number;
  private oldCoordinate?: LongLat;

  constructor(pathIndex: number, insertAt: number) {
    this.pathIndex = pathIndex;
    this.removeAt = insertAt;
  }

  apply(paths: Paths): Paths {
    this.oldCoordinate = paths[this.pathIndex][this.removeAt];

    const newPaths = [...paths];
    newPaths[this.pathIndex] = [...paths[this.pathIndex]];
    newPaths[this.pathIndex].splice(this.removeAt, 1);
    return newPaths;
  }

  revert(paths: Paths): Paths {
    if (!this.oldCoordinate) {
      return paths;
    }

    const newPaths = [...paths];
    newPaths[this.pathIndex] = [...paths[this.pathIndex]];
    newPaths[this.pathIndex].splice(this.removeAt, 0, this.oldCoordinate);
    this.oldCoordinate = undefined;
    return newPaths;
  }
}

export class MoveBoundsCommand implements EditBoundsCommand {
  private readonly newPaths: Paths;
  private oldPaths?: Paths;

  constructor(newPaths: Paths) {
    this.newPaths = newPaths;
  }

  apply(paths: Paths): Paths {
    this.oldPaths = paths;
    return this.newPaths;
  }

  revert(paths: Paths): Paths {
    if (!this.oldPaths) {
      return paths;
    }

    const newPaths = this.oldPaths;
    this.oldPaths = undefined;
    return newPaths;
  }
}
